import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Encuentra el elemento app
const appElement = document.getElementById("app");

// Verifica que appElement exista
if (!appElement) {
  console.error("No se pudo encontrar el elemento con ID 'app'");
} else {
  // Limpiar el contenido existente
  appElement.innerHTML = "";

  // Montar la aplicación directamente en el elemento app
  const root = createRoot(appElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
